export enum TNewSupplementResponseMode {
  CreateNew,
  MatchExisting,
  NeedMoreInfo,
  MarkAsMedication,
}
